import { createMetaGameActionObj } from './questsActions';
import { PROGRESS_TYPE } from '../reducers/studentProgressReducer';

const setLastAppLaunched = type =>
  createMetaGameActionObj('SET_LAST_APP_LAUNCHED', type);

export const setVocabAsLastLaunched = () => setLastAppLaunched(PROGRESS_TYPE.VOCAB);
export const setCloseReadingAsLastLaunched = () => setLastAppLaunched(PROGRESS_TYPE.CLOSE_READING);
export const setEreaderAsLastLaunched = () => setLastAppLaunched(PROGRESS_TYPE.EREADER);

export const fetchSessionProgress = () => (dispatch) => {
  const sessionProgressRaw = sessionStorage.getItem('sessionProgress');
  if (sessionProgressRaw) {
    dispatch(createMetaGameActionObj('LOAD_SESSION_PROGRESS', JSON.parse(sessionProgressRaw)));
  }
};

export const clearSessionProgress = () => (dispatch) => {
  sessionStorage.removeItem('sessionProgress');
  dispatch(createMetaGameActionObj('CLEAR_SESSION_PROGRESS'));
};
